export const DISCOUNT_LIST_REQUEST = "DISCOUNT_LIST_REQUEST";
export const DISCOUNT_LIST_SUCCESS = "DISCOUNT_LIST_SUCCESS";
export const DISCOUNT_LIST_FAIL = "DISCOUNT_LIST_FAIL";

export const DISCOUNT_DELETE_REQUEST = "DISCOUNT_DELETE_REQUEST";
export const DISCOUNT_DELETE_SUCCESS = "DISCOUNT_DELETE_SUCCESS";
export const DISCOUNT_DELETE_FAIL = "DISCOUNT_DELETE_FAIL";
